import BaseServiceRead from './BaseServiceRead';

export default class CompanyAgreementService extends BaseServiceRead {
    constructor() {
        super();
        this.path = 'bo/company-agreement';
    }

    getStatus() {
        return this.fetch(`${this.domain}/${this.path}/status`, {
            method: 'GET',
        }).then((res) => Promise.resolve(res));
    }

    acceptAgreement(agreementId) {
        const body = {agreementId};
        return this.fetch(
            `${this.domain}/${this.path}/accept`,
            {
                method: 'POST',
                body: JSON.stringify(body),
            },
             
        ).then((res) => Promise.resolve(res));
    }
}


